import styled from 'styled-components';

export const StyledPasswordExpirationSettingsForm = styled.form`
   padding: 6px 0 14px 10px;
`;
StyledPasswordExpirationSettingsForm.displayName = 'StyledPasswordExpirationSettingsForm';
